import Delicious from '../images/delimeals.png'
import Store from '../images/store-app.png'
import fashion from '../images/fashion-house.png'

const card_data = [
  {
    id: 1,
    image: Delicious,
    header: 'Food App',
    description:
      'This project is about an online food store where people can order food and have it sent to their specified address',
    about: 'React, Context API, Firebase, HTML5, CSS3, JavaScript, Netlify',
    link: 'https://mealdemo.netlify.app',
  },
  {
    id: 2,
    image: Store,
    header: 'Phone Store App',
    description:
      'This project is a template for an online store where used electronics are sold at a reduced price.',
    about: 'React, Styled component, JavaScript, HTML5, CSS3, Netlify',
    link: 'https://build-store-app.netlify.app',
  },
  {
    id: 3,
    image: fashion,
    header: 'Fashion House',
    description:
      'This is a landing page for a fashion house or school with a testimonial section.',
    about: 'HTML5, CSS3, Bootstrap',
    link: 'https://fashion-house.netlify.app',
  },
]

export default card_data
